import { render, staticRenderFns } from "./SupplierDocumentsInProgress.vue?vue&type=template&id=ba180900&scoped=true&"
import script from "./SupplierDocumentsInProgress.vue?vue&type=script&lang=js&"
export * from "./SupplierDocumentsInProgress.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDocumentsInProgress.vue?vue&type=style&index=0&id=ba180900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba180900",
  null
  
)

export default component.exports